import useAnalyticsContext from '@client/hooks/useAnalyticsContext';
import AnalyticsConstants from '@constants/analytics';
import { useCallback } from 'react';
import {
	DECISION_AREA_BY_STEP,
	PRICING_DETAILS_PRODUCT_AREA,
} from './trackingConstants';

interface TrackModalDismissedOptions {
	completed?: boolean;
}

export const useTrackEstimateModalDismissed = () => {
	const { track } = useAnalyticsContext();

	return useCallback(
		(step: number, options?: TrackModalDismissedOptions) => {
			track({
				event: AnalyticsConstants.BUTTON_CLICKED,
				properties: {
					product_area: PRICING_DETAILS_PRODUCT_AREA,
					button_action: options?.completed ? 'Estimate calculated' : 'Close',
					location: 'estimate request flow',
					decision_area: DECISION_AREA_BY_STEP[step] ?? 'contact form',
				},
			});
		},
		[track],
	);
};
